import React from 'react';
import { OvertimeClassificationModal, type OvertimeClassificationResult } from '../OvertimeClassificationModal';
import type { CostCentre, DayKey, Project, TimesheetEntry } from '@/types/timesheet';
import type { OvertimeType } from '@/types/timesheetSettings';

export interface OvertimeClassificationDialogProps {
  classifyOvertimeEntry: TimesheetEntry | null;
  setClassifyOvertimeEntry: React.Dispatch<React.SetStateAction<TimesheetEntry | null>>;
  classifyOvertimeSuggestedHours: Partial<Record<DayKey, number>>;
  setClassifyOvertimeSuggestedHours: React.Dispatch<React.SetStateAction<Partial<Record<DayKey, number>>>>;
  visibleDays: DayKey[];
  dayLabels: string[];
  activeOvertimeTypes: OvertimeType[];
  defaultOvertimeTypeId: number | undefined;
  handleClassifyOvertimeConfirm: (result: OvertimeClassificationResult) => void;
  handleProjectSearch: (query: string) => void;
  isSearchingProjects: boolean;
  allAvailableProjects: Project[];
  costCentres: CostCentre[];
  overtimeEnabled: boolean;
  companyId: string | undefined;
}

/** Splits a row's hours across the configured overtime types (task 2.17). */
export function OvertimeClassificationDialog({
  classifyOvertimeEntry,
  setClassifyOvertimeEntry,
  classifyOvertimeSuggestedHours,
  setClassifyOvertimeSuggestedHours,
  visibleDays,
  dayLabels,
  activeOvertimeTypes,
  defaultOvertimeTypeId,
  handleClassifyOvertimeConfirm,
  handleProjectSearch,
  isSearchingProjects,
  allAvailableProjects,
  costCentres,
  overtimeEnabled,
  companyId,
}: OvertimeClassificationDialogProps) {
  if (!classifyOvertimeEntry || !overtimeEnabled) return null;

  return (
    <OvertimeClassificationModal
      open={!!classifyOvertimeEntry}
      onOpenChange={(open) => {
        if (!open) {
          setClassifyOvertimeEntry(null);
          setClassifyOvertimeSuggestedHours({});
        }
      }}
      entry={classifyOvertimeEntry}
      visibleDays={visibleDays}
      dayLabels={dayLabels}
      overtimeTypes={activeOvertimeTypes}
      defaultOvertimeTypeId={defaultOvertimeTypeId}
      suggestedOvertimeHours={Object.keys(classifyOvertimeSuggestedHours).length > 0 ? classifyOvertimeSuggestedHours : undefined}
      onConfirm={handleClassifyOvertimeConfirm}
      nextEntryId={-Date.now()}
      projects={allAvailableProjects}
      costCentres={costCentres}
      onServerSearch={handleProjectSearch}
      isSearchingProjects={isSearchingProjects}
      companyId={companyId}
    />
  );
}
